module.exports = "https://static.wmbcdn.com/uniweb/images/4785b146aa5103dd4ecf31723d14d781.svg";